import React, { useState } from "react";
import { Modal, Form, InputNumber, Button, message } from "antd";
import SelectDiscountType from "src/components/Dropdown/SelectDiscountType";
import OrderPoolDataService from "src/services/OrderPoolDataService";
import ReportPoolDataService from "src/services/ReportPoolDataService";
import { formatCommas, parseFormat } from "src/utils";

const ModalUpdate = ({ open, onClose, initialValues, orderId, reload }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    // ---- TÍNH GIÁ SAU GIẢM ------------------
    const calcPriceDiscount = () => {
        const import_price = Number(form.getFieldValue("import_price") || 0);
        const discount_value = Number(form.getFieldValue("discount_value") || 0);
        const discount_type = form.getFieldValue("discount_type");
        let finalPrice = import_price;

        if (discount_type === "fixed") {
            finalPrice = import_price - discount_value;
        }

        if (discount_type === "percent") {
            finalPrice = import_price - (import_price * discount_value) / 100;
        }

        if (finalPrice < 0) finalPrice = 0;

        form.setFieldsValue({ price_discount: finalPrice });
    };

    // ---- SUBMIT API ---------------------------
    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();

            const payload = {
                import_price: values.import_price,
                // unit_price_gb: values.unit_price_gb,
                discount_type: values.discount_type,
                discount_value: Number(values.discount_value),
                price_discount: values.price_discount,
            };

            setLoading(true);

            const res = await ReportPoolDataService.updateReportPoolWallet(initialValues.ID, payload);

            message.success("Cập nhật giá thành công!");
            onClose();
            reload && reload(); // load lại table

        } catch (err) {
            console.error(err);
            message.error("Cập nhật thất bại!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Cập nhật giá gói Data"
            open={open}
            onCancel={onClose}
            footer={null}
            width={500}
            destroyOnClose
            afterOpenChange={() => {
                if (initialValues) form.setFieldsValue({
                    ...initialValues,
                    import_price: Number(initialValues.import_price)
                });
            }}
        >
            <Form
                layout="vertical"
                form={form}
            >
                {/* Giá */}
                <Form.Item
                    label="Giá nhập"
                    name="import_price"
                    rules={[{ required: true, message: "Vui lòng nhập giá" }]}
                >
                    <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        placeholder="Nhập giá nhập"
                        onChange={calcPriceDiscount}
                        formatter={value => formatCommas(value)}
                        parser={value => parseFormat(value)}
                    />
                </Form.Item>
                

                {/* Loại giảm giá */}
                <Form.Item label="Loại giảm giá" name="discount_type">
                    <SelectDiscountType onChange={calcPriceDiscount} />
                </Form.Item>

                {/* Giá trị giảm */}
                <Form.Item label="Giá trị giảm" name="discount_value">
                    <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        max={form.getFieldValue("discount_type") === "percent" ? 100 : undefined}
                        placeholder="Nhập giá trị giảm"
                        onChange={calcPriceDiscount}
                        formatter={(value) => formatCommas(value)}
                        parser={(value) => parseFormat(value)}
                    />
                </Form.Item>

                {/* Giá sau giảm */}
                <Form.Item label="Giá sau giảm" name="price_discount">
                    <InputNumber
                        style={{ width: "100%" }}
                        min={0}
                        placeholder="Giá sau khi áp dụng giảm"
                        disabled
                        formatter={value => formatCommas(value)}
                        parser={value => parseFormat(value)}
                    />
                </Form.Item>

                {/* Buttons */}
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                    <Button onClick={onClose}>Hủy</Button>
                    <Button type="primary" loading={loading} onClick={handleSubmit}>
                        Cập nhật
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};

export default ModalUpdate;
